import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=1b13dd5c&"
var script = {}
import style0 from "./notFound.vue?vue&type=style&index=0&id=1b13dd5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports